import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Data from '../DocumentiStipula/data/output';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import Doc01 from './tipoDoc/cessione_di_azienda';
import Doc02 from './tipoDoc/cessione_quote';
import Doc03 from './tipoDoc/compravendita_immobiliare';
import Doc04 from './tipoDoc/separazione_beni';
import Doc05 from './tipoDoc/costituzione_fondo_patrimoniale';
import Doc06 from './tipoDoc/procura';
import Doc07 from './tipoDoc/mutuo';
import Doc08 from './tipoDoc/donazione';
import Doc09 from './tipoDoc/dichiarazione_di_successione';
import Doc10 from './tipoDoc/costituzione_società';

import './styles.css';

const DocumentiStipulaCorpus = ({documentiStipulaID, isDesktopOrLaptop, isSmallScreen}) => {

  // stati OUTPUT RENDERING
  const [stampa, setStampa] = useState(false);

  const scaricaCert = () => {
    setStampa(true)
  }


  // FUNZIONI UPDATE STATI
  useEffect(() => {
    function PrintData() {
      if (stampa) {
        const input = document.getElementById('pagePrint')
        
        html2canvas(input , {
          dpi: 150, // Set to 300 DPI
          useCORS: true,
          scale: 2, // Adjusts your resolution
          }).then((canvas) => {
                var pdf = new jsPDF("pt", "mm", "a4");
                var position = 0;
                
                var imgData = canvas.toDataURL('image/png', 1.0);

                var imgWidth = 210; 
                var pageHeight = 297;  
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
      
                pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);  // hxw mm @ (0,0)mm
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                  position = heightLeft - imgHeight;
                  pdf.addPage("pt", "mm", "a4");
                  pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                  
                  heightLeft -= pageHeight;
                }

                pdf.save(`${documentiStipulaID}.pdf`);
            })
        setStampa(false)
      }
    }
    PrintData();

  }, [stampa]);

  return (
    <div id='documentoStampa'>
      {Data.map( item => {
        if (documentiStipulaID == item.link) {
          return (
            <div >
              <h1 className='titleCert'>Documenti per la stipula di <span className='titleCertCol'>{item.name}</span></h1>
              <Row style={{justifyContent: 'center'}}>
                <div  className={isDesktopOrLaptop ? 'bookDesktop book' : isSmallScreen ? 'bookSmall book' : 'bookMobile book'} >
                  <div id='pagePrint' className="pageDoc">
                      <div className="subpageDoc">

                        <div className='titleForm'>
                          <img src='https://www.notaio-treviso.com/logo.webp' title="Notaio a Treviso - Documenti stipula" alt="Notaio Treviso" style={{width:'50%',marginBottom: '40px'}}/>
                          <h2 className='h3title'>Notaio a Treviso - Studio notarile Falcinelli</h2> 
                          <h3 className='h2title'>Lista documenti per {item.name}</h3>
                        </div>

                        <div className='lineCert'>
                        
                          {(() => {
                            if (item.link === 'cessione-di-azienda') {
                              return (
                                <Doc01 />
                              );
                            }
                            if (item.link === 'cessione-quote') {
                              return (
                                <Doc02 />
                              );
                            }
                            if (item.link === 'compravendita-immobiliare') {
                              return (
                                <Doc03 />
                              );
                            }
                            if (item.link === 'separazione-beni') {
                              return (
                                <Doc04 />
                              );
                            }
                            if (item.link === 'costituzione-fondo-patrimoniale') {
                              return (
                                <Doc05 />
                              );
                            }
                            if (item.link === 'procura') {
                              return (
                                <Doc06 />
                              );
                            }
                            if (item.link === 'mutuo') {
                              return (
                                <Doc07 />
                              );
                            }
                            if (item.link === 'donazione') {
                              return (
                                <Doc08 />
                              );
                            }
                            if (item.link === 'dichiarazione-di-successione') {
                              return (
                                <Doc09 />
                              );
                            }
                            if (item.link === 'costituzione-società') {
                              return (
                                <Doc10 />
                              );
                            }                            
                            }
                          )()}
                        </div>

                        <div className='finishline'>
                        <img src="https://www.notaio-treviso.com/logo.webp" title="Logo Studio Notarile Falcinelli | Notaio a Treviso" alt="Notaio Treviso" style={{width:'50%',marginBottom: '40px'}}/>
                            <p>Studio Notarile Falcinelli</p>
                            <p>info@notaiofalcinelli.it - www.notaio-treviso.com</p>
                            <p>Via Cornarotta n.5, 31100 Treviso TV</p>
                            <p>+39 04221628653</p>
                        </div>

                      </div>    
                  </div>
                </div>
              </Row>
            </div>
          );
        }
      }
      )}
      <div className='boxbottoniCert'>
          <button className='bottoniCert' onClick={() => scaricaCert()}>Stampa lista documenti</button>
      </div>
    </div>
    
  );
};

export default DocumentiStipulaCorpus;
